import React from "react";
import { useDispatch } from "react-redux";
import { useUser } from "../../AuthContext";
import { INotification } from "./Index";
import { setNotificationClose } from "./redux/Slice";
import { PREPARE_TOAST_DISPLAYTIME } from "./Scripts";
import { NotificationView } from "./Notification.view";

export interface INotificationProps {

  /**
   * Notification object
   */
  notificationData: INotification;
}

type Props = INotificationProps;

/**
 * Responsible for rendering notification
 */
export const Notification: React.FC<Props> = (props: Props) => {

  const dispatch = useDispatch();
  const { logout } = useUser();
  const autoDeleteTime = props.notificationData.autoCloseTime ?
    props.notificationData.autoCloseTime : PREPARE_TOAST_DISPLAYTIME;

  if(props.notificationData.actionType === "auth-failed"){
    setTimeout(() => logout(), 3000);
  }

  /**
   * Callback to close notification
   */
  const closeNotify = (): void => {
    dispatch(setNotificationClose(props.notificationData));
    if(props.notificationData.actionType === "auth-failed"){
      logout();
    }
  };

  /**
   * Adding notification autoclose on timeout
   */
  React.useEffect(() => {
    const id = setTimeout(() => {
      dispatch(setNotificationClose(props.notificationData));
    }, autoDeleteTime);
    return (): void => {
      clearTimeout(id);
    };
  });

  return (
    <NotificationView notificationClose={closeNotify} notificationData={props.notificationData} />
  );
};
